export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_FAMILY',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_FAMILY_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_FAMILY_FAIL',
  
};
